import React from 'react'
import { NavLink } from 'react-router-dom'

const Footer = () => {
    return (
        <section className='py-5'>
            <div className="container">
                <div className="text-center mb-5">
                    <img src="./../images/logo.svg" className='mb-3' alt="Wero Flowers Logo" style={{ maxWidth: '130px' }} />
                    <p className='normal font__size--16 text__16-1024 color__gray-1'>
                        Ihr bezauberndes Gartencenter. Wir lieben es, wenn wir Ihnen mit Blumen und Pflanzen eine Freude bereiten können.
                    </p>
                </div>
                
                <div className="row justify-content-center mb-5">
                    <div className="col-md-4 col-lg-3">
                        <div className="d-md-flex text-center align-items-start justify-content-center">
                            <img src="./../images/a-1.png" className="mb-3 mb-md-0 object-fit-content" alt="" />
                            <div className="ml-2 font__size--16 text__16-1024">weroflowers@gmx.de</div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-3 my-4 my-md-0">
                        <div className="d-md-flex text-center align-items-start justify-content-center">
                            <img src="./../images/a.png" className="mb-3 mb-md-0 object-fit-content" alt="" />
                            <div className="ml-2 font__size--16 text__16-1024">Düsseldorfer Landstraße 189, 47249 Duisburg, Deutschland</div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-3">
                        <div className="d-md-flex text-center align-items-start justify-content-center">
                            <img src="./../images/a-2.png" className="mb-3 mb-md-0 object-fit-content" alt="" />
                            <div className="ml-2 font__size--16 text__16-1024">015208599686</div>
                        </div>
                    </div>
                </div>
                
                <div className="text-center">
                    <div className="mb-3">
                        <NavLink
                            to="/impressum"
                            className="medium font__size--14 text__14-1024 color__gray-1"
                        >
                            Impressum
                        </NavLink>
                    </div>
                    <div className="medium font__size--12 text__12-1024 color__gray-1">
                        © {new Date().getFullYear()} Wero Flowers. Alle Rechte vorbehalten.
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer
